<script>
    import { _ } from "../services/i18n.js";
    import Dialog from "./Dialog.svelte";
    import Form from "./Form.svelte";
    import { createEventDispatcher } from "svelte";
    import { uploadImage, getImageUrl, editImageData, deleteImage, isInUse } from "../services/images.js";

    const dispatch = createEventDispatcher();

    export let maxSize = null;

    let showDialog;
    let hideDialog;
    let setFieldValue;

    const DialogMode = Object.freeze({
        Create: "create",
        Edit: "edit"
    });

    let mode = DialogMode.Create;
    let editPreviewImageUrl = null;
    let currentEditImage = null;
    let imageInUse = false;

    const onSubmit = async evt => {
        if (mode == DialogMode.Create) {
            const imageData = await uploadImage(evt.detail);
            dispatch("imageUpdated", imageData);
        }
        else {
            const imageData = await editImageData(evt.detail);
            dispatch("imageUpdated", imageData);
        }
        hideDialog();
    }

    
    export const show = async (editImage) => {
        if (!editImage) {
            currentEditImage = null;
            mode = DialogMode.Create;
            imageInUse = false;

            setFieldValue('name', '', true);
            setFieldValue('file', '', true);
            setFieldValue('metadata', '', true);
        }
        else {
            currentEditImage = editImage;
            mode = DialogMode.Edit;
            editPreviewImageUrl = null;

            imageInUse = await isInUse(editImage.id);
            
            // El setTimeout es necesario porque se muestran dos formularios diferentes
            // en función del DialogMode que se acaba de establecer arriba. Hay que esperar
            // para que la funcioń `setFieldValue` esté correctamente enlazada al
            // formulario que toca
            setTimeout(() => {
                setFieldValue('id', editImage.id, true);
                setFieldValue('name', editImage.name, true);
                setFieldValue('metadata', editImage.metadata, true);
                editPreviewImageUrl = getImageUrl(editImage);
            }, 10);
        }
        showDialog();
    }

    export const hide = () => {
        hideDialog();
    }

    function onImageSet(evt) {
        const file = evt.detail[0];
        if (file) {
            const fileName = file.name;
            setFieldValue('name', fileName, false);
        }
    }

    let confirmDeletePress = false;
    const deleteImagePressed = async () => {
        confirmDeletePress = true;
    }

    const confirmDelete = async (evt) => {
        await deleteImage(currentEditImage.id);
        hideDialog();
        dispatch("imageUpdated", currentEditImage);
    }
    
    const cancelDelete = async (evt) => {
        confirmDeletePress = false;
    }
</script>

<Dialog bind:show={showDialog} bind:hide={hideDialog}>
    <section>
        <header>
            <h4>{mode === DialogMode.Create ? $_("ui.uploadImageDialog.uploadNew") : $_("ui.uploadImageDialog.editImageData")}</h4>
        </header>
        <article>
            {#if mode == DialogMode.Create}
                <Form fields={[
                    { type: "string", name: "name", id: "name", label: "Nombre", placeholder: "Nombre de la imagen", required: true },
                    { type: "imageUpload", name: "file", id: "file", label: "Archivo", required: true, onChanged: onImageSet, maxSize: maxSize },
                    { type: "string", name: "metadata", id: "metadata", label: "Metadatos", placeholder: "Datos de catalogación separados por comas" }
                ]} bind:setFieldValue={setFieldValue} on:submit={onSubmit} on:cancel={() => hide()} buttonLabel="ui.form.save" />
            {:else}
                <Form fields={[
                    { type: "hidden", name: "id", id: "id" },
                    { type: "string", name: "name", id: "name", label: "Nombre", placeholder: "Nombre de la imagen", required: true },
                    { type: "string", name: "metadata", id: "metadata", label: "Metadatos", placeholder: "Datos de catalogación separados por comas" }
                ]} bind:setFieldValue={setFieldValue} on:submit={onSubmit} on:cancel={() => hide()} buttonLabel="ui.form.save">
                    {#if imageInUse}
                       <button type="button" class="danger" disabled title={$_("images.noDeleteImageInUse")}>{$_("ui.form.delete")}</button>
                    {:else}
                        <button type="button" class="danger" on:click={deleteImagePressed}>{$_("ui.form.delete")}</button>
                    {/if}
                </Form>
                {#if confirmDeletePress }
                    <div class="delete-button-container confirm">
                        <h3>{$_("images.deleteConfirmMessage")}</h3>
                        <button class="delete-image-button confirm danger" on:click={confirmDelete}>{$_("ui.form.delete")}</button>
                        <button class="delete-image-button confirm" on:click={cancelDelete}>{$_("ui.form.cancel")}</button>
                    </div>
                {/if}
                <div class="preview-container">
                    <img src={editPreviewImageUrl} alt="Vista previa de la imagen" />
                </div>
            {/if}
        </article>
    </section>
</Dialog>

<style>

    .delete-button-container.confirm {
        padding: 10px;
        background: rgb(240 240 240 / 80%);
        position: absolute;
        right: 0px;
        top: 0px;
        left: 0px;
        bottom: 0px;
        backdrop-filter: blur(5px);
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        justify-content: center;
    }

    .delete-button-container h3 {
        text-wrap: wrap;
        white-space: wrap;
        font-size: 18px;
        text-align: center
    }

    button.danger {
        background: red;
        color: white;
    }

    button.danger:disabled {
        opacity: 40%;
        cursor: not-allowed
    }

    .preview-container > img {
        background: #ccc;
    }

</style>